/** True when the tab is in the foreground (avoid sounds, toasts, and loading flashes). */
export function isPageVisible() {
  return typeof document === 'undefined' || document.visibilityState === 'visible';
}
